document.addEventListener("DOMContentLoaded", () => {

  // Klaviyo Form Input Class Toggle
  const formSelector = ".Footer_innerside_innerright_forms_new";

  if (formSelector) {
    const formObserver = new MutationObserver(() => {
      const form = document.querySelector(formSelector);

      if (form) {
        const emailInput = form.querySelector('input[type="email"]');

        if (emailInput) {

          const toggleTypingClass = () => {
            emailInput.classList.toggle(
              "typing",
              emailInput.value.trim() !== ""
            );
          };

          emailInput.addEventListener("input", toggleTypingClass);

          emailInput.addEventListener("blur", function () {
            if (this.value.trim() === "") {
              this.classList.remove("typing");
            }
          });

          emailInput.addEventListener("focus", toggleTypingClass);

          formObserver.disconnect();
        }
      }
    });

    formObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }


  // Lazy Load Videos
  const videos = document.querySelectorAll(".lazy-video");

  const isMobile = () => window.innerWidth <= 750;

  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      const video = entry.target;

      if (!video.dataset.src) return;

      const isMobileVideo = video.classList.contains("Mobile_video_new");
      const isDesktopVideo = video.classList.contains("Desktop_video_new");

      if (
        (isMobile() && isDesktopVideo) ||
        (!isMobile() && isMobileVideo)
      ) {
        video.pause();
        return;
      }

      if (!video.dataset.loaded) {
        video.src = video.dataset.src;
        video.load();
        video.dataset.loaded = "true";
      }

      if (entry.intersectionRatio >= 0.6) {
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }

    });
  }, {
    threshold: [0, 0.6],
    rootMargin: "200px"
  });

  videos.forEach(video => videoObserver.observe(video));

});